<script>
import { Doughnut, mixins } from 'vue-chartjs'

const { reactiveProp } = mixins
export default {
  name: 'ChartDoughnut',
  extends: Doughnut,
  mixins: [reactiveProp],
  props: ['chartData', 'options'],
  watch: {
    options: {
      deep: true,
      handler() {
        this.renderChart(this.chartData, this.options)
      },
    },
  },
  mounted() {
    this.renderChart(this.chartData, this.options)
  },
}
</script>
